<nz-page-header nzTitle="Product List"></nz-page-header>
<a [routerLink]="['/product/new']" nz-button nzType="dashed" class="mb-1" >+ Create Product</a>
<div class="row mt-3">
	<div class="col">
		<app-table
			[data]="data"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[filters]="filters"
			[loading]="loading"
			[disablePaging]="false"
			(onRowClick)="doView($event)"
			(onUpdateRequired)="doFetchResults($event)">
		</app-table>
	</div>
</div>
